import router from '../routes';

// Helper functions to set, get, and delete cookies
function setCookie(name, value, days) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    const expires = "; expires=" + date.toUTCString();
    document.cookie = name + "=" + (value || "") + expires + "; path=/; SameSite=None; Secure";
}

function deleteCookie(name) {   
    setCookie(name, "", -1);
}

export default {

    /**
     * When the user successfuly logs in
     * Set access_token and profile data into localstorage
     * Set access_token and profile data into state
     * Load User profile data and set to state
     * Configure Axios interceptor to add Bearer token to every request
     */
    login(state, user) {
        setCookie('access_token', user.access_token, 30);
        setCookie('account_data', JSON.stringify(user.user), 30);

        // Set user state
        state.user = {
            ...state.user,
            token: user.access_token,
            account: user.user,
        };

        state.isLoggedIn = true;

        // Configure the Bearer token insertion
        state.user.token_interceptor = window.axios.interceptors.request.use((config) => {
            config.headers.Authorization = `Bearer ${user.access_token}`;

            return config;
        });
    },


    setToken(state, token) {
        // Configure the Bearer token insertion
        state.user.token_interceptor = window.axios.interceptors.request.use((config) => {
            config.headers.Authorization = `Bearer ${token}`;

            return config;
        });
    },


    /**
     * After logging out clear data from localstorage and state
     * Clear Axios interceptor from adding bearer tokens.
     */
    logout(state) {
        deleteCookie('access_token');
        deleteCookie('account_data');
        
        window.axios.interceptors.request.eject(state.user.token_interceptor);

        state.user = {
            token: null,
            account: {},
            profile: {},
            token_interceptor: {},
            auth_interceptor: {},
        };

        state.isLoggedIn = false;

        router.push('/');
    },


    setProfileData(state, profileData) {
        state.user.profile = profileData;
    },
};
